import  { HANDLE_ATTENDANCE, RESET } from "../actions";
import moment from "moment";

const initialState = {
    startDate: moment().subtract(6, "month"),
    endDate: moment(),
    attendance: [], 
    userId: "",
    status: "",
    page: 1
};

const Report = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_ATTENDANCE : 
            return {
                ...state,
                ...action.data
            }
        case RESET :
            return initialState
        default:
            return state;
    }
}

export default Report;